export const newsTabs = [
    {key: "latest", label: "最新"},
    {key: "notice", label: "公告"}
];

export function emptyNewsLists() {
    return newsTabs.reduce(function (lists, tab) {
        lists[tab.key] = [];
        return lists;
    }, {});
}

export function buildNewsLists(items) {
    const newsItems = Array.isArray(items) ? items : [];

    return newsTabs.reduce(function (lists, tab) {
        if (tab.key === "latest") {
            lists[tab.key] = newsItems;
        } else {
            lists[tab.key] = newsItems.filter(function (item) { return item.tab === tab.key; });
        }
        return lists;
    }, {});
}
